import { Component } from '@angular/core';
import { RegulatedProductService } from '../../regulated-products.service';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import {
  ICustomizedFormat,
  IHierarchyFormat,
  REGULATED_PRODUCT_TTL_ES
} from '../../regulated-product.interface';
import { MessageService } from 'primeng/api';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'pg-regulated-product-create',
  templateUrl: './regulated-products-create.component.html',
  providers: [MessageService]
})
export class RegulatedProductCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  itemDigemid: { label: string; value: string }[];
  select = {
    item: {
      type: 'single',
      openDialog: false,
      id: undefined
    }
  };
  disabled: boolean;
  hasPurchaseFormat = false;
  hasMinSaleFormat = false;
  length0fObject: any;
  clonedHierarchyFormat: { [s: string]: IHierarchyFormat } = {};
  clonedCustomizedFormat: { [s: string]: ICustomizedFormat } = {};
  hierarchyFormats = [];
  statuses = [];
  nameList = [];
  hierarchyFormatLength = 0;
  customizedFormatLength = 0;
  details = {};
  formatObj: any;
  constructor(
    private regulatedProductService: RegulatedProductService,
    private fb: FormBuilder,
    private messageService: MessageService
  ) {
    super(REGULATED_PRODUCT_TTL_ES, regulatedProductService);
  }

  ngOnInit() {
    this.disabled = false;
    this.hierarchyFormats = [
      {
        id: 1,
        nombre: '',
        subFormat: '',
        cantidad: 1,
        FV: false,
        FMV: false,
        FC: true
      }
    ];
    this.fg = this.fb.group({
      barCode: ['', [Validators.minLength(5), Validators.maxLength(32)]]
    });
    this.setItemDetails();
  }

  onSelectedItem(event) {
    if (event) {
      this.select.item.id = event.code;
      this.details = event;
      this.setItemDetails();
    }
    this.select.item.openDialog = false;
  }

  onHierarchyRowEdit(product: IHierarchyFormat) {
    this.clonedHierarchyFormat[product.id] = { ...product };
  }

  onHierarchyRowEditSave(product: IHierarchyFormat) {
    if (this.hierarchyFormats[product.id]) {
      this.hierarchyFormats[product.id].nombre = product.subFormat;
    }
    delete this.clonedHierarchyFormat[product.id];
    this.checkEssentialFormatsExistence();
  }

  onHierarchyRowEditCancel(product: IHierarchyFormat, index: number) {
    this.hierarchyFormats[index] = this.clonedHierarchyFormat[product.id];
    delete this.clonedHierarchyFormat[product.id];
    this.checkEssentialFormatsExistence();
  }

  onHierarchyAddRow(ri: number) {
    this.disabled = true;
    this.hierarchyFormats.push({
      id: ri + 2,
      nombre: this.hierarchyFormats[ri].subFormat,
      subFormat: null,
      cantidad: null,
      FV: false,
      FMV: false,
      FC: false
    });
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
  }

  onHierarchyDeleteRow() {
    if (this.hierarchyFormats[this.hierarchyFormatLength - 1].id == 1) {
      this.disabled = false;
    }
    this.hierarchyFormats.pop();
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
    this.checkEssentialFormatsExistence();
  }

  onChangeCheck(ri) {
    for (let index = 0; index < this.hierarchyFormats.length; index++) {
      if (index !== ri) {
        this.hierarchyFormats[index].FMV = false;
      }
    }
    this.hierarchyFormats[ri].subFormat = undefined;
  }

  onSetNameList() {
    this.statuses = [];
    for (let index = 0; index < this.hierarchyFormats.length; index++) {
      this.statuses.push({
        label: this.hierarchyFormats[index].nombre,
        value: this.hierarchyFormats[index].nombre
      });
    }
    this.statuses.push({ label: 'Vacío', value: '' });
  }

  setItemDetails() {
    const fieldsStock = {
      code: 'Código',
      name: 'Nombre',
      concentration: 'Concentración',
      form: 'Fórmula',
      formSimp: 'Fórmula Abreviada',
      presentation: 'Presentación',
      laboratory: 'Laboratorio',
      fractions: 'Fracción'
    };
    const keysStock = Object.keys(fieldsStock);
    this.itemDigemid = keysStock.map((key) => {
      return {
        label: fieldsStock[key],
        value: this.details[key] ? this.details[key] : '-'
      };
    });
  }

  getFormatObject() {
    const myObj = {};
    for (const key in this.hierarchyFormats) {
      const element = this.hierarchyFormats[key];
      if (element.nombre) {
        myObj[element.nombre] = {
          subFormat: element.subFormat === null ? undefined : element.subFormat,
          quantitySubFormat: element.cantidad,
          isFormatSale: element.FV,
          isFormatSaleMin: element.FMV,
          isFormatPurchase: element.FC
        };
      }
    }
    this.length0fObject = 0;
    this.formatObj = myObj;
    for (const key in this.formatObj) {
      this.length0fObject++;
    }
    return true;
  }

  checkEssentialFormatsExistence() {
    this.hasPurchaseFormat = false;
    this.hasMinSaleFormat = false;
    for (const format of this.hierarchyFormats) {
      if (
        Object.prototype.hasOwnProperty.call(format, 'FMV') &&
        format['FMV'] === true
      ) {
        this.hasMinSaleFormat = true;
      }

      if (
        Object.prototype.hasOwnProperty.call(format, 'FC') &&
        format['FC'] === true
      ) {
        this.hasPurchaseFormat = true;
      }
    }
  }

  async onSubmit() {
    if (this.isReadyToCreate()) {
      if (this.getFormatObject()) {
        const formatObject = this.formatObj;
        for (const formatDetail of Object.values(formatObject)) {
          if (
            formatDetail['isFormatSale'] == true &&
            formatDetail['isFormatSaleMin'] == false &&
            (formatDetail['quantitySubFormat'] == null ||
              formatDetail['quantitySubFormat'] <= 0)
          ) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Cantidad de subformato de venta (Cnt.S.F.V) invalido',
              detail: 'Recuerda añadir la cantidad en el campo  (Cnt.S.F.V) '
            });
            return;
          }
        }
        const payload = {
          digemidProductId: this.select.item.id,
          format: formatObject,
          barCode: this.fg.value.barCode
        };
        if (this.fg.value.barCode == '') {
          delete payload.barCode;
        }
        this.createItem$(payload);
      }
    }
  }

  isReadyToCreate() {
    return (
      this.select.item.id &&
      this.hierarchyFormats[0].nombre &&
      this.hierarchyFormats[this.hierarchyFormatLength].subFormat == undefined
    );
  }
}
